/* BC Motion — calm, premium micro-interactions (site-wide). No dependencies. */
(function () {
  if (window.bcMotion) return;
  var d = document, w = window;
  var calm = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = w.Shopify && w.Shopify.designMode;
  var api = (w.bcMotion = {});

  /* ---------- 1. Scroll progress + header shadow ---------- */
  var bar = d.createElement('div');
  bar.id = 'bcm-progress';
  bar.setAttribute('aria-hidden', 'true');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var h = d.documentElement.scrollHeight - w.innerHeight;
      bar.style.setProperty('--bcm-p', h > 0 ? Math.min(1, w.scrollY / h).toFixed(4) : 0);
      d.body.classList.toggle('bcm-scrolled', w.scrollY > 12);
      ticking = false;
    });
  }

  /* ---------- 2. Scroll reveal ---------- */
  var ITEM_SEL = [
    '.bc-steps > *', '.bc-ugc > *', '.bc-benefits > *', '.bc-stats > *', '.bc-testi-grid > *', '.bc-metrics > *',
    '.bcr-grid > *', '.bc-bars > *', '.bc-avatars > *', '.bc-accordion > details', '.bc-table tbody tr',
    'product-card', '.product-card', '.product-grid > li', '.blog-post-card'
  ].join(',');
  function setupReveal() {
    if (calm || design || !('IntersectionObserver' in w)) return;
    var main = d.getElementById('MainContent');
    if (!main) return;
    var vh = w.innerHeight;
    var items = Array.prototype.slice.call(main.querySelectorAll(ITEM_SEL));
    var blocks = Array.prototype.slice.call(main.querySelectorAll('.bc-wrap > *, .bc-hero__inner > *'))
      .filter(function (el) {
        return !el.matches('style,script,template') && !items.some(function (i) { return el.contains(i); });
      });
    var all = items.concat(blocks).filter(function (el) {
      if (el.closest('[data-bc-anim], .bc-sticky-atc, header, footer, dialog, .bcps-show')) return false;
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.top > vh * 0.92; /* never hide what is already on screen */
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('bcm-in');
        io.unobserve(el);
        setTimeout(function () {
          el.classList.remove('bcm-r', 'bcm-r--zoom', 'bcm-in');
          el.style.removeProperty('--bcm-d');
        }, 1800);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    all.forEach(function (el) {
      var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--bcm-d', Math.min(idx, 5) * 80 + 'ms');
      el.classList.add('bcm-r');
      if (el.matches('figure, .bc-split__media, .bc-gallery, .bcps-card')) el.classList.add('bcm-r--zoom');
      io.observe(el);
    });
    /* Safety net: nothing on screen ever stays hidden */
    setInterval(function () {
      d.querySelectorAll('.bcm-r:not(.bcm-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < w.innerHeight && r.bottom > 0) el.classList.add('bcm-in');
      });
    }, 1200);
  }

  /* ---------- 3. Click ripple + press feedback ---------- */
  var CLICK_SEL = '.bc-btn, .button, button[type="submit"], .add-to-cart-button, .shopify-payment-button__button, .bc-tier__label, .bc-gallery__thumb, summary, .quantity-selector button, [role="button"], .header__icon';
  function ripple(ev) {
    var host = ev.target.closest && ev.target.closest(CLICK_SEL);
    if (!host || calm) return;
    host.classList.add('bcm-press-able', 'bcm-pressed');
    var release = function () {
      host.classList.remove('bcm-pressed');
      w.removeEventListener('pointerup', release);
      w.removeEventListener('pointercancel', release);
    };
    w.addEventListener('pointerup', release);
    w.addEventListener('pointercancel', release);
    if (host.matches('summary, .header__icon')) return; /* press only, no ripple */
    var r = host.getBoundingClientRect();
    var cs = w.getComputedStyle(host);
    if (cs.position === 'static') host.classList.add('bcm-ripple-host');
    else if (cs.overflow === 'visible') host.style.overflow = 'hidden';
    var m = (cs.backgroundColor.match(/[\d.]+/g) || []).map(Number);
    var transparent = m.length < 3 || (m.length > 3 && m[3] === 0);
    var light = !transparent && (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) > 170;
    var s = d.createElement('span');
    s.className = 'bcm-ripple' + (light || transparent ? ' bcm-ripple--dark' : '');
    s.style.setProperty('--s', Math.max(r.width, r.height) * 2.2 + 'px');
    s.style.setProperty('--x', ev.clientX - r.left + 'px');
    s.style.setProperty('--y', ev.clientY - r.top + 'px');
    host.appendChild(s);
    setTimeout(function () { s.remove(); }, 700);
  }

  /* ---------- 4. Smooth accordions (<details>) ---------- */
  function animateDetails(det, open) {
    var sum = det.querySelector('summary');
    if (calm || !sum) { det.open = open; return; }
    var start = det.offsetHeight;
    det.classList.add('bcm-anim');
    if (open) det.open = true;
    else det.classList.add('bcm-closing');
    var end = open ? det.scrollHeight : sum.offsetHeight + (det.offsetHeight - det.clientHeight);
    det.style.height = start + 'px';
    void det.offsetHeight;
    det.style.height = end + 'px';
    var finished = false;
    var done = function (e) {
      if (finished || (e && e.target !== det)) return;
      finished = true;
      det.removeEventListener('transitionend', done);
      if (!open) det.open = false;
      det.classList.remove('bcm-anim', 'bcm-closing');
      det.style.height = '';
    };
    det.addEventListener('transitionend', done);
    setTimeout(done, 520);
  }
  api.closeDetails = function (det) { animateDetails(det, false); };
  function onSummaryClick(ev) {
    var sum = ev.target.closest && ev.target.closest('summary');
    if (!sum) return;
    var det = sum.parentElement;
    if (!det || det.tagName !== 'DETAILS') return;
    /* Only content accordions (FAQ etc.) — menus, drawers and popovers are left alone */
    if (!det.closest('.bc-accordion, .bc-faq')) return;
    ev.preventDefault();
    animateDetails(det, !det.open);
  }

  /* ---------- 5. Cart count pop ---------- */
  function watchCart() {
    var bump = function (el) { el.classList.remove('bcm-pop'); void el.offsetWidth; el.classList.add('bcm-pop'); };
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        var el = m.target.nodeType === 3 ? m.target.parentElement : m.target;
        var b = el && el.closest && el.closest('.cart-bubble');
        if (b) bump(b);
      });
    });
    d.querySelectorAll('.cart-bubble, cart-icon, .header__icon--cart').forEach(function (el) {
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    d.body.appendChild(bar);
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll, { passive: true });
    onScroll();
    setupReveal();
    d.addEventListener('pointerdown', ripple, { passive: true });
    d.addEventListener('click', onSummaryClick);
    watchCart();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
